import { render, staticRenderFns } from "./PeriodFilter.vue?vue&type=template&id=38608080&"
import script from "./PeriodFilter.ts?vue&type=script&lang=ts&"
export * from "./PeriodFilter.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports